var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNeutralEmoji(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6273 18.6273 24 12 24C5.37333 24 0 18.6273 0 12C0 5.37333 5.37333 0 12 0C18.6273 0 24 5.37333 24 12Z",
    fill: "#FFCC4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66667 13.3327C8.58714 13.3327 9.33333 12.288 9.33333 10.9993C9.33333 9.71068 8.58714 8.66602 7.66667 8.66602C6.74619 8.66602 6 9.71068 6 10.9993C6 12.288 6.74619 13.3327 7.66667 13.3327Z",
    fill: "#664500"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3337 13.3327C17.2541 13.3327 18.0003 12.288 18.0003 10.9993C18.0003 9.71068 17.2541 8.66602 16.3337 8.66602C15.4132 8.66602 14.667 9.71068 14.667 10.9993C14.667 12.288 15.4132 13.3327 16.3337 13.3327Z",
    fill: "#664500"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.667 17.3333H7.33366C6.96566 17.3333 6.66699 17.0353 6.66699 16.6667C6.66699 16.298 6.96566 16 7.33366 16H16.667C17.0357 16 17.3337 16.298 17.3337 16.6667C17.3337 17.0353 17.0357 17.3333 16.667 17.3333Z",
    fill: "#664500"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutralEmoji);
export default __webpack_public_path__ + "static/media/neutral_emoji.146dd9f33562c9680d34423d01e6c934.svg";
export { ForwardRef as ReactComponent };